// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/text_format.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/planners/v1/resources/text_format.proto.
 */
export const file_studyo_today_planners_v1_resources_text_format = /*@__PURE__*/
  fileDesc("CjRzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3RleHRfZm9ybWF0LnByb3RvEiJzdHVkeW8udG9kYXkucGxhbm5lcnMudjEucmVzb3VyY2VzKnUKClRleHRGb3JtYXQSGwoXVEVYVF9GT1JNQVRfVU5TUEVDSUZJRUQQABIaChZURVhUX0ZPUk1BVF9QTEFJTl9URVhUEAESFAoQVEVYVF9GT1JNQVRfSFRNTBACEhgKFFRFWFRfRk9STUFUX01BUktET1dOEANCKqoCJ1N0dWR5by5Ub2RheS5QbGFubmVycy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the enum studyo.today.planners.v1.resources.TextFormat.
 */
export const TextFormatSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_planners_v1_resources_text_format, 0);

/**
 * All possible representations of text to display.
 *
 * @generated from enum studyo.today.planners.v1.resources.TextFormat
 */
export const TextFormat = /*@__PURE__*/
  tsEnum(TextFormatSchema);

